// extracted by mini-css-extract-plugin
export default {"homeLoaderWrapper":"Loading_homeLoaderWrapper__YMvnO","loaderImageHomeLoaderRegular":"Loading_loaderImageHomeLoaderRegular__sSvUx"};